import React, { useState, useEffect } from 'react';
import { useAuth } from '../../utils/authService';
import { db } from '../../utils/firebase-config';
import { doc, setDoc, collection, addDoc, getDocs, query, where } from "firebase/firestore"; 
import emailjs from '@emailjs/browser'; // Import EmailJS
import { Link, useNavigate } from "react-router-dom";
import useConstantContactService from '../../api/useConstantContactService';  // Import ConstantContactService
import GoogleLogo from '../../assets/google.png';
import axios from 'axios';  // Import axios to send data to the backend
import Layout from '../Layout';
import Accordion from '../ui/Accordion'; // Import the reusable Accordion component
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const SignUp = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [firstName, setFirstName] = useState(''); 
  const [lastName, setLastName] = useState(''); 
  const [aboutMe, setAboutMe] = useState(''); 
  const [dateOfBirth, setDateOfBirth] = useState(''); 
  const navigate = useNavigate();
  const { signup, signInWithGoogle } = useAuth();
  const [errorMessage, setErrorMessage] = useState('');  
  const [showPassword, setShowPassword] = useState(false);

  // Define the allowed pattern
  const validatePassword = (password) => {
    const minLength = password.length >= 8;
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*]/.test(password);
    const hasInvalidChar = /[^A-Za-z0-9!@#$%^&*]/.test(password); // Detects spaces & restricted characters

    if (!minLength) return "Password must be at least 8 characters long.";
    if (!hasUppercase) return "Password must include at least one uppercase letter.";
    if (!hasLowercase) return "Password must include at least one lowercase letter.";
    if (!hasNumber) return "Password must include at least one number.";
    if (!hasSpecialChar) return "Password must include at least one special character (!@#$%^&*).";
    if (hasInvalidChar) return "Password contains invalid characters (avoid spaces and unsupported symbols).";

    return ''; // No errors
  };

  const fetchEmailJSConfig = async () => {
    try {
      const response = await fetch("https://us-central1-online-resource-center.cloudfunctions.net/getEmailJSConfig");
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching EmailJS config:", error);
      return null;
    }
  };
  

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setPasswordError(validatePassword(newPassword));
  };

  const signUpListItems = [
    {
      title: "Visionary Masterclasses",
      content:
        "Establish a solid foundation with insights from Black economic experts who deeply understand our history and envision the future. Learn strategies for leadership, business ownership, and wealth creation that tackle the root causes of global Black disparities.",
    },
    {
      title: "Hands-On Tools and Workshops",
      content:
        "Turn knowledge into action with practical, customized workshops that address personal, generational, and communal wealth-building. From debt elimination plans to business development resources, every tool is designed to elevate your skills and amplify your impact.",
    },
    {
      title: "Community of Like-Minded Changemakers",
      content:
        "Connect with a global network of peers who share your vision for Black empowerment and success. Form meaningful connections, find mentorship, and build partnerships that inspire growth and collaboration.",
    },
    {
      title: "Exclusive Content for Financial and Entrepreneurial Success",
      content:
        "Access video interviews, workshops, and curated podcasts featuring philanthropic Black entrepreneurs and financial experts from around the world—all dedicated to building lasting change and success.",
    },
  ];
  


  //https://diff-quizz-latest.vercel.app/signup
      // Step 1: Redirect to Constant Contact authorization URL

  const saveUserProfileToFirestore = async (userId, userProfile) => {
    const userRef = doc(db, "users", userId);
    const isFullWidth = true;

    //console.log(process.env.REACT_APP_CONSTANT_CONTACT_ACCESS_TOKEN);

    try {
        await setDoc(userRef, {
            email: email, 
            firstName: firstName, 
            lastName: lastName, 
            aboutMe: aboutMe, 
            dateOfBirth: dateOfBirth, 
            username: "",
            image: "",
            bio: "",
            displayName: '',
            currentStep: 0,
            masterclassCompleted: false, 
            masterClassSubStep: 0,
            progress: {
              "Masterclass": 0,
              "Finances & Philanthropy": 2,
              "Entrepreneurship & Philanthropy": 8,
              "Community-Minded Business Concept Form": 12,
              "Wealth Building Stage": 21
            }
        });

        await setDoc(userRef, userProfile, { merge: true }); // Merge ensures existing data is not overwritten

        // Create additional collections if needed
        await addDoc(collection(db, 'users', userId, 'Community_Minded_Business_Concept_Form'), {
          createdAt: new Date().toISOString(),
        });
        await addDoc(collection(db, 'users', userId, 'Wealth_Building_Stage', 'Undepting', 'Past', 'data'), {
          createdAt: new Date().toISOString(),
        });
        await addDoc(collection(db, 'users', userId, 'Wealth_Building_Stage', 'Undepting', 'Next', 'data'), {
          createdAt: new Date().toISOString(),
        });
    } catch (error) {
        console.error(error);
    }
  };



  const handleCallback = async () => {
    // Step 2: Handle redirect and exchange code for token
    const code = new URLSearchParams(window.location.search).get('code');
    if (code) {
      try {
        const tokenResponse = await axios.post('https://authz.constantcontact.com/oauth2/default/v1/token', {
          grant_type: 'authorization_code',
          code,
          redirect_uri: process.env.REACT_APP_CONSTANT_CONTACT_REDIRECT_URI,
          client_id: process.env.REACT_APP_CONSTANT_CONTACT_CLIENT_ID,
          client_secret: process.env.REACT_APP_CONSTANT_CONTACT_CLIENT_SECRET
        }, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
  
        const accessToken = tokenResponse.data.access_token;
        const refreshToken = tokenResponse.data.refresh_token;
        const expires_in = tokenResponse.data.expires_in;
  
        // Use the access token to make API requests to Constant Contact
        await useConstantContactService.addUserToList(email, firstName, lastName, accessToken);
  
        // Handle token refresh
        setTimeout(async () => {
          try {
            const refreshResponse = await axios.post('https://authz.constantcontact.com/oauth2/default/v1/token', {
              grant_type: 'refresh_token',
              refresh_token: refreshToken,
              client_id: process.env.REACT_APP_CONSTANT_CONTACT_CLIENT_ID,
              client_secret: process.env.REACT_APP_CONSTANT_CONTACT_CLIENT_SECRET
            }, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            });
  
            const newAccessToken = refreshResponse.data.access_token;
            // Use the new access token for subsequent requests
          } catch (error) {
            console.error(error);
          }
        }, expires_in * 1000 - 30000); // Refresh token 30 seconds before it expires
      } catch (error) {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    handleCallback();
  }, []);


   // Function to send a Welcome Email using EmailJS
   const sendWelcomeEmail = async (userEmail, userFirstName) => {
    // const emailConfig = await fetchEmailJSConfig();
    // if (!emailConfig) {
    //   console.error("Failed to load EmailJS config.");
    //   return;
    // }

    const templateParams = {
      to_email: userEmail,
      to_name: userFirstName,
      subject: "Welcome to Online Resource Center! 🎉",
     //message: `Dear ${userFirstName}, welcome to the Online Resource Center! 🎉! We are excited to have you on board.`,
    };

    const emailHTML = `
    <div style="font-family: Arial, sans-serif; max-width: 600px; padding: 20px; border: 1px solid #ddd; border-radius: 10px;">
      <h2 style="color: #fcb900;">Online Resource Center, ${userFirstName}!</h2>
      <p>We are excited to have you as a part of our community.</p>
      <p>Here’s what you can expect:</p>
      <ul>
        <li>Access to exclusive masterclasses</li>
        <li>Hands-on workshops & mentorship</li>
        <li>A supportive and empowering network</li>
      </ul>
      <p>Click the button below to explore:</p>
      <a href="https://diffcenter.diffvelopment.com" 
        style="display:inline-block; padding:10px 20px; background:#fcb900; color:#000; text-decoration:none; font-weight:bold; border-radius:5px;">
        Get Started
      </a>
      <p>Welcome aboard! 🚀</p>
      <p>Best, <br />Online Resource Center Team</p>
    </div>
  `;

  try {
    await emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,  // Replace with EmailJS Service ID
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,  // Replace with EmailJS Template ID
      {
        to_email: userEmail,
        to_name: userFirstName,
        message_html: emailHTML // Pass the HTML email directly
      },
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY    // Replace with EmailJS Public Key
    );
    console.log("Welcome email sent successfully!");
  } catch (error) {
    console.error("Failed to send welcome email:", error);
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
  
    try {
      // 🔥 Step 1: Check Firestore for an existing user with this email
      const usersRef = collection(db, "users");
      const querySnapshot = await getDocs(query(usersRef, where("email", "==", email)));
  
      if (!querySnapshot.empty) {
        setErrorMessage("This email is already registered. Please sign in or use Google.");
        return;
      }
  
      // 🔥 Step 2: Create account if email is not found
      const userInfo = await signup(email, password);
      const currentUser = userInfo.user;
  
      await saveUserProfileToFirestore(currentUser.uid);
      await sendWelcomeEmail(email, firstName);
  
      localStorage.setItem('uid', currentUser.uid);
      navigate('/survey/0/0');
    } catch (error) {
      if (error.code === 'auth/email-already-in-use') {
        setErrorMessage('The email address is already in use by another account.');
      } else {
        setErrorMessage('Failed to sign up. Please try again.');
      }
      console.error("Sign up error:", error);
    }
  };
  

  const handleGoogleSignIn = async () => {
    try {
        const userInfo = await signInWithGoogle();
        const user = userInfo.user;

        // Extract user details correctly
        const email = user.email;
        const firstName = user.displayName?.split(" ")[0] || "User";

        // Check if user already exists in Firestore
        const usersRef = collection(db, "users");
        const querySnapshot = await getDocs(query(usersRef, where("email", "==", email)));

        if (!querySnapshot.empty) {
            console.log("User already exists in Firestore.");
            navigate('/survey/0');
            return;
        }

        // Save user to Firestore
        const userProfile = {
            email: email,
            firstName: firstName,
            lastName: user.displayName?.split(" ")[1] || "Last Name",
            aboutMe: "...",
            dateOfBirth: "",
            username: "",
            image: user.photoURL || "",
            bio: "",
            displayName: user.displayName || "",
            masterclassCompleted: false,
            masterClassSubStep: 0,
            currentStep: 0,
            progress: {
                "Masterclass": 0,
                "Finances & Philanthropy": 2,
                "Entrepreneurship & Philanthropy": 8,
                "Community-Minded Business Concept Form": 12,
                "Wealth Building Stage": 21,
            },
        };

        await saveUserProfileToFirestore(user.uid, userProfile);

        // Send welcome email (ensure email and firstName are correctly passed)
        await sendWelcomeEmail(email, firstName);

        // Redirect based on profile completion
        if (!userProfile.dateOfBirth) {
            navigate('/profile'); 
        } else {
            navigate('/survey/0/0');
        }
    } catch (error) {
        console.error("Google Sign-In error:", error);
    }
};

  
  

  return (

    <div className="flex max-[992px]:flex-col min-h-screen w-full max-[992px]:pt-8">
         {/* Left Column */}
         <div className="min-[992px]:w-1/2 flex max-[767px]:pb-4 max-[1300px]:pb-24 min-[1300px]:pt-44 min-[1900px]:pt-14 flex-col justify-center items-start min-[992px]:pr-20 max-[992px]:pr-6 pl-6">
        <h1 className="text-4xl font-extrabold orange-text mb-6">Welcome to the DIFF Center</h1>
        <p>
        <strong>Unlock a world of insight, empowerment, and opportunity.</strong>
        <br />
        <video
          className="relative inset-0 w-full min-h-40 mt-5 max-h-80 object-cover min-[992px]:hidden"
          autoPlay
          muted
          loop
          src="https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/video%2Fsignup.mp4?alt=media&token=740a770e-8959-4f50-939c-ed53134c1aec"
        />
    <br />
    <br />
        The DIFF Center is more than just an online platform—it’s a vibrant community
and educational hub, built specifically to address the unique challenges and
opportunities faced by Black entrepreneurs, students, and young professionals
worldwide. As a member, you’ll gain access to invaluable knowledge that sets
you apart as a forward-thinking leader with a deep understanding of the
historical and global contexts of Black economic empowerment.
          </p>
          <br />
          <p>When you join the DIFF Center, you’ll gain access to:

</p>
<br />
    {/* <ul className="list-disc max-[992px]:hidden">
      {signUpListItems.map((item, index) => (
        <li key={index} className="mt-3">
          <strong>{item.title}</strong> <br />
          {item.content}
        </li>
      ))}
    </ul> */}
    <Accordion className="" items={signUpListItems} />

    <br />
    <p>  <strong>Stand out, lead boldly, and create your legacy.</strong> Sign up today to begin your
    journey toward visionary leadership and transformative impact.</p>
      </div>

         {/* Right Column */}
         <div className="relative flex items-center justify-center max-[992px]:border-t-2 max-[767px]:mt-4 max-[767px]:pt-0 min-[992px]:w-2/3 max-[992px]:mt-8 pt-8 pb-8">
        <video
          className="absolute inset-0 w-full h-full object-cover max-[992px]:hidden"
          autoPlay
          muted
          loop
          src="https://firebasestorage.googleapis.com/v0/b/online-resource-center.appspot.com/o/video%2Fsignup.mp4?alt=media&token=740a770e-8959-4f50-939c-ed53134c1aec"
        />
      <div className="relative bg-white p-8 shadow-lg rounded-md z-10 max-w-lg min-[1300px]:mt-14 max-[992px]:min-w-[400px]  max-[767px]:min-w-[90%] min-[992px]:min-w-[450px]">
        <h3 className="text-2xl font-bold text-center">Create Your Account</h3>
       
        <form onSubmit={handleSubmit}>
        <div className="mt-4 flex">
        <div className="w-1/2 mr-1">
            <label className="block" htmlFor="email">Email</label>
            <input 
              type="email" 
              placeholder="Email" 
              className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required 
            />
          </div>
          <div className="w-1/2 ml-1">
            <label className="block" htmlFor="password">Password</label>
            <div className="relative">
          <input 
            type={showPassword ? "text" : "password"}
            className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"
            value={password}
            onChange={handlePasswordChange}
            placeholder="Password"
            required
          />
          <button
            type="button"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600"
            onClick={() => setShowPassword(!showPassword)}
          >
            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
          </button>

        </div>
        {passwordError && <p className="text-red-600 text-sm mt-1">{passwordError}</p>}

          </div>
          </div>
          <div className="mt-4 flex">
            <div className="w-1/2 mr-1">
            <label className="block" htmlFor="firstName">First Name</label>
            <input 
              type="text" 
              className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder="First Name"
              required
            />
          </div>
       
          <div className="w-1/2 ml-1">
            <label className="block" htmlFor="lastName">Last Name</label>
            <input 
              type="text" 
              className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder="Last Name"
              required
            />
          </div>
          </div>
          <div className="mt-4">
            <label className="block" htmlFor="dateOfBirth">Date of Birth</label>
            <input 
              type="date" 
              className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"
              value={dateOfBirth}
              onChange={(e) => setDateOfBirth(e.target.value)}
              required
            />
          </div>
          <div className="mt-4">
            <label className="block" htmlFor="aboutMe">Your Story</label>
            <textarea 
              className="min-h-28 w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"
              value={aboutMe}
              onChange={(e) => setAboutMe(e.target.value)}
              placeholder="Share what drives you and how you hope to connect and grow within the DIFF Center community."
              required
            />
          </div>

          <div className="flex items-baseline justify-center">
            <button className="px-6 py-2 mt-4 orange-bg font-semibold rounded-full hover:bg-amber-600 transition-colors" type="submit">Sign Up</button>
          </div>
          <div className='mt-5 text-center'>
            <Link to='/signin'>Sign in?</Link>
        </div>
          <div className='text-center mt-5 mb-5 tracking-[-1.7px]'>
         --- O R ---
          </div>

          <button onClick={handleGoogleSignIn} className="bg-gray-200 text-black ml-auto mr-auto mt-5 font-semibold py-3 px-6 rounded-2xl flex items-center space-x-2">
          Sign Up with Google  
          <img 
                src={GoogleLogo} 
                alt="Google Logo" 
                className="w-6 h-6 ml-2" 
            />
        </button>

          {errorMessage && (
            <div className="mt-4 text-red-600">
                {errorMessage}
            </div>
          )}
        </form>
      
      </div>
      </div>
    </div>

  );
};

export default SignUp;
